import React from 'react';
import { withTheme } from '../ThemeProvider';
import { StyledDrawerHeader } from './styles';
import { Title } from './Title';

export interface DrawerHeaderProps {
  title?: string | React.ReactNode;
  icon?: React.ReactNode;
  className?: string;
  theme?: any;
}

const HeaderComponent: React.FC<DrawerHeaderProps> = ({
  title,
  icon,
  className,
}: DrawerHeaderProps) => {
  return (
    <StyledDrawerHeader>
      {typeof title === 'string' ? (
        <Title title={title} icon={icon} className={className} />
      ) : (
        title
      )}
    </StyledDrawerHeader>
  );
};

export const Header = withTheme(HeaderComponent);
